import { theme } from 'antd';
import React from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';

export function ThemeProvider({ children }: React.PropsWithChildren) {
  const { token } = theme.useToken();
  return (
    <StyledThemeProvider
      theme={{
        antd: token,
      }}
    >
      {children}
    </StyledThemeProvider>
  );
}
